import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import EmailToTenantReducer from "../reducers/EmailToTenantReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { EmailToTenantConstants } from "../constants/emailtotenant.constants";
import { saveFile } from "../utils/common";
const initialState = {
  emailToTenants: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  emailToTenantSearchResults: [],
  emailToTenant: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  isLoadingDownload: false,

  emailToTenantAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  autoSearchLoading: false,
  isLoading: true,
  isLoadingAutoSearch: true,
  downloadFileType: "",
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const EmailToTenantContext = createContext({
  ...initialState,
  getAllEmailToTenant: () => {},
  addEmailToTenant: () => {},
  downloadFile: () => {},
});

function EmailToTenantProvider({ children }) {
  const [state, dispatch] = useReducer(EmailToTenantReducer, initialState);

  const getAllEmailToTenant = async (payload) => {
    try {
      dispatch({
        type: EmailToTenantConstants.FETCH_EMAILTOTENANT_REQUEST,
      });
      const response = await axios.post("/cpanel/tenant/list", payload);

      dispatch({
        type: EmailToTenantConstants.FETCH_EMAILTOTENANT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: EmailToTenantConstants.FETCH_EMAILTOTENANT_FAILURE,
      });
    }
  };

  const addEmailToTenant = async (payload) => {
    const response = await axios.post("cpanel/tenant/send-email", payload);
    dispatch({
      type: EmailToTenantConstants.ADD_EMAILTOTENANT_REQUEST,
    });
    dispatch({
      type: EmailToTenantConstants.ADD_EMAILTOTENANT_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: EmailToTenantConstants.DOWNLOAD_EMAILTOTENANT_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/cpanel/tenant/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "tenant." + fileType);

    dispatch({
      type: EmailToTenantConstants.DOWNLOAD_EMAILTOTENANT_SUCCESS,
      payload: response.data,
    });
  };

  return (
    <EmailToTenantContext.Provider
      value={{
        ...state,
        getAllEmailToTenant,
        addEmailToTenant,
        downloadFile,
      }}
    >
      {children}
    </EmailToTenantContext.Provider>
  );
}

export { EmailToTenantContext, EmailToTenantProvider };
